<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateAssignProjectManagerPreference(value: boolean) {
  await settingsStore.set('projectsAssignProjectManager', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.projectsAssignProjectManager"
    :label="t('settings.projects.assignAsProjectManager')"
    :description="t('settings.projects.assignAsProjectManagerDescription')"
    @change="updateAssignProjectManagerPreference"
  />
</template>